import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  timeout: 30000,
});

let refreshing = null;

export const refreshSession = () => {
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  return refreshing;
};

export const isAuthRejection = (e) => [401, 403].includes(e?.response?.status);

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    const detail = error.response?.data?.detail;
    if (error.response?.status === 403 && typeof detail === "string" && detail.includes("bloqueado") && !orig?.url?.includes("/auth/login")) {
      window.dispatchEvent(new Event("auth:logout"));
    }
    if (error.response?.status === 402) window.dispatchEvent(new Event("auth:reload"));
    if (error.response?.status === 401 && orig && !orig._retry && !orig.url.includes("/auth/")) {
      orig._retry = true;
      try {
        await refreshSession();
        return api(orig);
      } catch (e) {
        if (isAuthRejection(e)) window.dispatchEvent(new Event("auth:logout"));
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errorMessage = (e) => {
  if (e?.code === "ECONNABORTED") return "O servidor demorou para responder. Verifique sua internet e tente novamente.";
  if (!e?.response) return "Sem conexão com o servidor. Verifique sua internet e tente novamente.";
  if (e.response.status >= 500) return "O sistema está instável no momento. Aguarde alguns segundos e tente novamente.";
  return formatApiErrorDetail(e.response.data?.detail);
};
